angular.module('impactx.catalogruleresult').controller('CatalogRuleWithoutProductEncryptionViewListCtrl',
    CatalogRuleWithoutProductEncryptionViewListCtrl);

CatalogRuleWithoutProductEncryptionViewListCtrl.$inject = ['$routeParams'];

function CatalogRuleWithoutProductEncryptionViewListCtrl($routeParams)
{
    this.meta = {
        rowTemplate: 'modules/catalogruleresult/templates/catalogrulewithoutproductencryptionview.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/catalogruleresult/rulewithoutproductencryptionview',
        id: "catalogrulewithoutproductencryptionviewlist",
        params: {'cmrliId': $routeParams.id},
        excelParams: {
            params: [{param: 'CMRLIId', intValue: $routeParams.id}]
        },
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    }
}